import React, { useState, useEffect } from 'react'
import NavItem from 'components/NavItem'
import { Button } from '@arnsbogroup/react-voicearchive'
import { Link } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'
import Logo from 'components/Logo'
import Icon from 'components/Icon'
import FooterA from './FooterA'
import { messages as routes } from 'routes'
import useUtmUrl from 'useUtmUrl'

const Footer = () => {
  const [open, setOpen] = useState(false)
  const toggle = () => setOpen(!open)
  const { formatMessage, locale } = useIntl()

  return (
    <div className="bg-primary w-full h-auto">
      <div className="max-w-screen-xl mx-auto flex items-center justify-between flex-wrap text-white md:px-0">
        <div className="px-4 md:px-5 w-full">
          <div className="flex justify-between items-center mt-20 mb-20">
            <Link
              to={useUtmUrl('/')}
              aria-label={formatMessage(messages.contactUs)}
            >
              <Logo title={formatMessage(messages.contactUs)} className="h-6" />
            </Link>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-0">
              <a
                href={formatMessage(messages.contactUsHref)}
                className="w-full md:w-40"
              >
                <Button variant="plain" className="w-full">
                  <FormattedMessage {...messages.contactUs} />
                </Button>
              </a>

              <Link
                to={useUtmUrl(formatMessage(routes.explore).replace('/*', ''))}
                className="w-full md:w-40 md:ml-6"
              >
                <Button variant="plain" className="w-full">
                  <FormattedMessage {...messages.explore} />
                </Button>
              </Link>
            </div>
          </div>

          <div className="border-t w-full py-2 border-primary-darker md:flex justify-between items-center">
            <div className="flex-grow">
              <FooterA
                href={useUtmUrl(formatMessage(messages.applyAsVoiceTalentHref))}
              >
                <FormattedMessage {...messages.applyAsVoiceTalent} />
              </FooterA>

              <FooterA href={useUtmUrl(formatMessage(messages.faqHref))}>
                <FormattedMessage {...messages.faq} />
              </FooterA>

              <FooterA
                href={useUtmUrl(formatMessage(messages.termsAndConditionsHref))}
              >
                <FormattedMessage {...messages.termsAndConditions} />
              </FooterA>

              <FooterA
                href={useUtmUrl(formatMessage(messages.privacyPolicyHref))}
              >
                <FormattedMessage {...messages.privacyPolicy} />
              </FooterA>
            </div>

            <div className="">
              <Icon
                icon={['fab', 'cc-visa']}
                className="text-3xl mx-2"
                title="VISA"
              />
              <Icon
                icon={['fab', 'cc-mastercard']}
                className="text-3xl mx-2"
                title="MasterCard"
              />
              <Icon
                icon={['fab', 'cc-discover']}
                className="text-3xl mx-2"
                title="Discover"
              />
              <Icon
                icon={['fab', 'cc-amex']}
                className="text-3xl mx-2"
                title="American Express"
              />
              <Icon
                icon={['fab', 'cc-paypal']}
                className="text-3xl mx-2"
                title="PayPal"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
